<div style="width: 670px">
	<form id="KranSetup" [formGroup]="SetupForm" (ngSubmit)="sucheKran()">
		<br />
		<fieldset id="RuestzustandBereich">
			<legend>
				<ng-container i18n="Heading parts selection|Heading for selection of configuration of crane@@HeadingPartSelection">Parts Selection</ng-container>&nbsp;
				<span *ngIf="kranname !== ''"> <ng-container  i18n="Text for|Just text: for@@For">for</ng-container>
					{{kranname}}
				</span>
			</legend>
			<div class="Zeile clearfix">
				<div class="FeldMitBeschreibung">
					<div class="Beschreibung">Combination:</div>
					<div class="EingabeFeld">
						<select id="Kombination" formControlName="Kombination"
							(change)="ruestzustandAendern($event)">
							<option *ngFor="let kombination of kombinationen"
								[value]="kombination"
								[selected]="gesetzteKombination == kombination">{{kombination}}</option>
						</select>
						<div class="infobereich bstooltip">
							<!--Info Icon-->
							<div class="info-icon" id="info-icon"></div>
							<div class="tooltiptext below" style="width:240px; text-align:left;margin-left: -120px;">
								<table>
									<tr>
										<td>MB</td>
										<td i18n="Tooltip main boom|Text for tooltip@@MainBoom">main boom</td>
									</tr>
									<tr>
										<td>SA</td>
										<td i18n="Tooltip side assist|Text for tooltip@@SideAssist">side assist</td>
									</tr>
									<tr>
										<td>SA_H</td>
										<td i18n="Tooltip side assist hydraulic|Text for tooltip@@SideAssistHydraulic">side assist (hydraulic)</td>
									</tr>
									<tr>
										<td>BE</td>
										<td i18n="Tooltip boom extension|Text for tooltip@@BoomExtension">boom extension</td>
									</tr>
									<tr>
										<td>BE_H</td>
										<td i18n="Tooltip boom extensionhydraulic|Text for tooltip@@BoomExtensionHydraulic">boom extension (hydraulic)</td>
									</tr>
									<tr>
										<td>HDJ</td>
										<td i18n="Tooltip heavy duty jib|Text for tooltip@@HeavyDutyJib">heavy duty jib</td>
									</tr>
									<tr>
										<td>HDJ_H</td>
										<td i18n="Tooltip heavy duty jib hydraulic|Text for tooltip@@HeavyDutyJibHydraulic">heavy duty jib (hydraulic)</td>
									</tr>
									<tr>
										<td>LJ</td>
										<td i18n="Tooltip luffing jib|Text for tooltip@@LuffingJib">luffing jib</td>
									</tr>
									<tr>
										<td>..._MWL</td>
										<td i18n="Tooltip inclusive MegaWingLift|Text for tooltip@@InclusiveMegaWingLift">inclusive MegaWingLift</td>
									</tr>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="Zeile clearfix">
				<div class="FeldMitBeschreibung">
					<div class="Beschreibung">Chart Number:</div>
					<div class="EingabeFeld">
						<select id="Identnr" formControlName="Identnr"
							(change)="ruestzustandAendern($event)">
							<option *ngFor="let identnr of identnummern" [value]="identnr"
								[selected]="gesetzteIdentnr == identnr">{{identnr}}</option>
						</select>
					</div>
				</div>
			</div>
			<div class="Zeile clearfix">
				<div class="FeldMitBeschreibung">
					<div class="Beschreibung">
					<ng-container
						i18n="Label counterweight|Label for Counterweight@@LabelCounterweight">Counterweight</ng-container>:</div>
					<div class="EingabeFeld">
						<select id="Gegengew" formControlName="Gegengew"
							(change)="ruestzustandAendern($event)">
							<option *ngFor="let gegengewicht of gegengewichte"
								[value]="gegengewicht"
								[selected]="gesetztesGegengew == gegengewicht">{{gegengewicht}}</option>
						</select> <span class="Bemassung_Dropdown">{{gewichtsEinheit}}</span>
					</div>
				</div>
				<div class="FeldMitBeschreibung">
					<div class="Beschreibung"><ng-container i18n="Label support|Label for support in 360° setup@@Support">Support</ng-container>:</div>
					<div class="EingabeFeld">
						<select id="AbstuetzW" formControlName="AbstuetzW"
							(change)="ruestzustandAendern($event)">
							<option *ngFor="let abstuetzung of abstuetzungen"
								[value]="abstuetzung"
								[selected]="gesetzteAbstuetzung == abstuetzung">{{abstuetzung}}</option>
						</select>
					</div>
				</div>
			</div>
			<div class="Zeile clearfix">
				<div class="FeldMitBeschreibung">
					<div class="Beschreibung"><ng-container i18n="Label MB|Label for main boom length@@LabelMainBoomLength">Main Boom Length</ng-container>:</div>
					<div class="EingabeFeld">
						<select id="HALaenge" formControlName="HALaenge"
							(change)="ruestzustandAendern($event)">
							<option *ngFor="let haLaenge of haLaengen" [value]="haLaenge"
								[selected]="haLaenge == gesetzteHALaenge">{{rundeHAWerte(haLaenge,
								stellenNachEinheitenSystem)}}</option>
						</select> <span class="Bemassung_Dropdown">{{laengenEinheit}}</span>
					</div>
				</div>
				<div class="FeldMitBeschreibung">
					<div class="Beschreibung">
					<ng-container
						i18n="Label MB angle|Label for main boom angle@@LabelMainBoomAngle">Main
					Boom Angle</ng-container>:</div>
					<div class="EingabeFeld">
						<select id="HAWinkel" formControlName="HAWinkel"
							(change)="ruestzustandAendern($event)">
							<option *ngFor="let haW of haWinkel" [value]="haW"
								[selected]="haW == gesetzterHAWinkel">{{haW}}</option>
						</select> <span class="Bemassung_Dropdown">°</span>
					</div>
				</div>
			</div>
			<div class="Zeile clearfix">
				<div class="FeldMitBeschreibung">
					<div class="Beschreibung">
					<ng-container
						i18n="Label MB Sequence|Label for main boom sequence@@LabelMainBoomSequence">Boom
					Sequence</ng-container>:</div>
					<div class="EingabeFeld">
						<select id="HAAusfahrf" formControlName="HAAusfahrf"
							(change)="ruestzustandAendern($event)">
							<option *ngFor="let ausfahrfolge of haAusfahrfolgen"
								[value]="ausfahrfolge"
								[selected]="gesetzteHAAusfahrf == ausfahrfolge">{{ausfahrfolge}}</option>
						</select>
					</div>
				</div>
			</div>
			<div class="Zeile clearfix">
				<div class="FeldMitBeschreibung">
					<div class="Beschreibung"><ng-container i18n="Label jib length|Label for jib length in 360° setup@@JibLength">Jib Length</ng-container>:</div>
					<div class="EingabeFeld">
						<select id="HI1Laenge" formControlName="HI1Laenge"
							(change)="ruestzustandAendern($event)">
							<option *ngFor="let hi1Laenge of hi1Laengen" [value]="hi1Laenge"
								[selected]="gesetzteHI1Laenge == hi1Laenge">{{hi1Laenge}}</option>
						</select> <span class="Bemassung_Dropdown">{{laengenEinheit}}</span>
					</div>
				</div>
				<div class="FeldMitBeschreibung">
					<div class="Beschreibung"><ng-container i18n="Label jib angle|Label for jib angle in 360° setup@@JibAngle">Jib Angle</ng-container>:</div>
					<div class="EingabeFeld">
						<select id="HI1Winkel" formControlName="HI1Winkel"
							(change)="ruestzustandAendern($event)">
							<option *ngFor="let hi1W of hi1Winkel" [value]="hi1W"
								[selected]="gesetzterHI1Winkel == hi1W">{{hi1W}}</option>
						</select> <span class="Bemassung_Dropdown">°</span>
					</div>
				</div>
			</div>
		</fieldset>
		<br />
		<fieldset id="RLHBereich">
			<legend i18n="Heading Requirements@Heading for Requirements in setup dialog for 360° setup@@HeadingRequirementsSetup">Requirements</legend>
			<div id="RLHRadius"><ng-container
				i18n="Label Radius|Label for radius input in setup dialog@@Radius">Radius</ng-container>: <input type="text" id="Radius" formControlName="Radius"
					(keyup.enter)="sucheKran()" /><span
					class="Bemassung">{{laengenEinheit}}</span>
			</div>
			<div id="RLHLast">
				<ng-container i18n="Label load|Label for input field load in setup@@Load">Load</ng-container>
				: <input type="text" id="Last" formControlName="Last"
					(keyup.enter)="sucheKran()" /><span
					class="Bemassung">{{gewichtsEinheit}}</span>
			</div>
			<div id="RLHHoehe">
				<ng-container i18n="Label Height|Label for input field height in setup@@Height">Height</ng-container>
				: <input type="text" id="Hoehe" formControlName="Hoehe"
					(keyup.enter)="sucheKran()" /><span
					class="Bemassung">{{laengenEinheit}}</span>
			</div>
		</fieldset>
		<br />
		<fieldset id="FormularButtons">
			<div>
				<div id="formular-steuerung">
					<!-- <input type="button" name="suche" value="Search"
						(click)="sucheKran()" /> -->
						<a class="css-button" (click)="sucheKran()">
							<span class="css-button-text"><ng-container i18n="Button Search|Label for a search button@@Search">Search</ng-container></span>
						</a>
						 <!-- <input type="button" name="reset"
						value="reset" (click)="resetFilter('alles')" /> -->
						<a class="css-button" (click)="resetFilter('alles')">
							<span class="css-button-text"><ng-container i18n="Button reset|Label for a reset button@@Reset">Reset</ng-container></span>
						</a>
				</div>
				<div id="ablauf-steuerung">
					<!-- <input type="button" name="Back" value="Back" i18n-value="Button Back|Label for back button in 360° setup@@Back"
						(click)="goBack()" /> -->
						<a class="css-button" (click)="goBack()">
							<span class="css-button-text"><ng-container i18n="Button Back|Label for back button in 360° setup@@Back">Back</ng-container></span>
						</a>
						 <!-- <input type="button" name="Continue"
						value="Continue" i18n-value="Button continue| Label for continue button in 360° setup@@Continue" (click)="go360TableControl()"
						*ngIf="kranGewaehlt()" /> -->
						<a *ngIf="kranGewaehlt()" class="css-button" (click)="go360TableControl()">
							<span class="css-button-text"><ng-container i18n="Button continue| Label for continue button in 360° setup@@Continue">Continue</ng-container></span>
						</a>
				</div>
			</div>
		</fieldset>
	</form>
	<div>
		<span (click)="sortierInfoZeigenUmschalten()"
			style="cursor: pointer; font-weight: bold;"><ng-container i18n="Infos on sort Order|Text for sort order@@SetupSortOrder">Info on sorting</ng-container> (<span *ngIf="!zeigeSortierInfos" i18n="Simple text@Text for show in setup MAXBase@@Show">show</span><span
			*ngIf="zeigeSortierInfos" i18n="Simple text|Text for hide in setup MAXbase@@Hide">hide</span>) </span> <span
			*ngIf="zeigeSortierInfos"> <br /> <ng-container i18n="Infos on table sorting|Information regarding the sorting of a table@@InfoTableSorting">To
			dynamically sort a particular column, click on its column header. The
			order switches between ascending and descending each time you click a
			column header for sorting.<br />
			You can sort more than one column by pressing “Ctrl key + mouse left
			click” on the column header.<br />
			To clear sorting for particular column, press “Shift + mouse left
			click”.</ng-container>
		</span>
	</div>

	<span id="RuesttabelleBereich"> <ej-grid #KranTabelle
			allowResizeToFit="true" [allowFiltering]="true"
			[filterSettings]="filterSettings" [allowPaging]="true"
			[pageSettings]="tabellenEinstellungen['pageSettings']"
			[allowSorting]="true" [allowMultiSorting]="true"
			[dataSource]="gridData" selectionType="single" allowSelection="true"
			[selectionSettings]="tabellenEinstellungen['selectionMode']"
			(rowSelected)="rowSelected()"> <e-columns> <e-column
			field="Geraet" i18n-headerText="heading model|Table heading for model in MAXbase setup@@Model" headerText="model" [visible]="false"></e-column>
		<e-column field="Identnr" i18n-headerText="heading identnr|Table heading for identnr in MAXbase setup@@IdentNr" headerText="chart number"></e-column>
		<e-column field="Pruefnorm" i18n-headerText="heading testing standard|Table heading for testing standard in MAXbase setup@@TestingStandard" headerText="standard"
			[visible]="false"></e-column> <e-column field="Kombination"
			i18n-headerText="heading combination|Table heading for combination in MAXbase setup@@Combination" headerText="combination" [visible]="true"></e-column>
		<e-column field="HALaenge" i18n-headerText="heading boom lenght|Table heading for boom length in MAXbase setup@@BoomLength" headerText="boom length"></e-column>
		<e-column field="HAWinkel" i18n-headerText="heading boom angle|Table heading for boom angle in MAXbase setup@@BoomAngle" headerText="boom angle"></e-column>
		<e-column field="HAAusfahrf" i18n-headerText="heading boom sequence|Table heading for boom sequence in MAXbase setup@@BoomSequence"
			headerText="boom sequence"></e-column> <e-column field="HILaenge"
			i18n-headerText="heading jib length|Table heading for jib length in MAXbase setup@@JibLength" headerText="jib length" [visible]="true"></e-column>
		<e-column field="HIWinkel" i18n-headerText="heading jib angle|Table heading for jib angle in MAXbase setup@@JibAngle" headerText="jib angle"
			[visible]="true"></e-column> <e-column field="Gegengew"
			i18n-headerText="heading counterweight|Table heading for counterweight in MAXbase setup@@Counterweight" headerText="ctwt"></e-column> <e-column
			field="Zentralblst" i18n-headerText="heading central ballast|Table heading for central ballast in MAXbase setup@@CentralBallast" headerText="CB" [visible]="true"></e-column>
		<e-column field="AbstuetzW" i18n-headerText="heading support|Table heading for support in MAXbase setup@@Support" headerText="support"
			[visible]="true"></e-column> <e-column field="Einscher"
			i18n-headerText="heading number of lines heading for number of lines in MAXbase setup@@NumberOfLinesAbbreviated" headerText="no. of lines" [visible]="true"></e-column>
		<e-column field="minRadius" i18n-headerText="heading minimal radius|Table heading for minimal radius in MAXbase setup@@MinimalRadiusAbbreviated" headerText="min. radius"></e-column>
		<e-column field="maxRadius" i18n-headerText="heading maximal radius|Table heading for maximal radius in MAXbase setup@@MaximalRadiusAbbreviated" headerText="max. radius"></e-column>
		<e-column field="minHoehe" i18n-headerText="heading minimal tip height|Table heading for minimal tip height in MAXbase setup@@MinimalTipHeightAbbreviated"
			headerText="min. tip heigth" [visible]="false"></e-column> <e-column
			field="maxHoehe" i18n-headerText="heading maximal tip height|Table heading for maximal tip height in MAXbase setup@@MaximalTipHeightAbbreviated" headerText="max. tip heigth"></e-column>
		<e-column field="maxLast" i18n-headerText="heading max load|Table heading for max load in MAXbase setup@@MaxLoadAbbreviated" headerText="max. load"></e-column>
		<!--<e-column field="Drehrichtung" headerText="slew direction" ></e-column> -->
		</e-columns> </ej-grid>
	</span>
</div>
<div *ngIf="bitteWarten()" class="sanduhr">
	<div class="sanduhrDisplay"></div>
</div>
<app-fehlermeldung [FehlerUeberschrift]="FehlerUeberschrift"
	[FehlerHinweis]="FehlerHinweis"
	[(zeigeFehlerMeldungSchalter)]="zeigeFehlerMeldung"
	[FehlerCallback]="FehlerCallback"></app-fehlermeldung>